import { GQLBugTracker } from '../../types/bug-trackers'

export const normalizeBugTrackers: (bugTrackers: any[]) => GQLBugTracker[] = (
  bugTrackers: any[]
) =>
  bugTrackers.map(
    ({
      bugtracker_name: name,
      bugtracker_type: type,
      creation_time: creation,
      ticket_key: ticketKey,
      ticket_title: ticketTitle,
      ticket_url: ticketUrl
    }) => {
      return {
        name,
        type,
        creation,
        ticketKey,
        ticketTitle,
        ticketUrl
      }
    }
  ) || []
